/**
 * plugins/lang.ts
 *
 * Vue I18n configuration for internationalization
 */

import { createI18n } from 'vue-i18n'
import en from '../../language/en.json'

const i18n = (form) => {
    return createI18n({
        legacy: false,
        locale: 'en',
        fallbackLocale: 'en',
        messages: {
            en: {
                common: en.common,                
                ...en[form]
            }
        }
    })
};

export default i18n
